import React from 'react';
import Modal from '../../components/Modal/modal';
import Grid from '@material-ui/core/Grid/';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  submitBtn: {
    margin: theme.spacing(1),
    width: '100%',
    color: 'white',
  },
}));

const TermsAndConditionsModal = (props) => {
  const { show, close, text, onAcceptClick } = props;
  const title = 'AMERA Terms And Conditions';
  const classes = useStyles();

  // const dummyText =
  //   'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla cursus erat pretium orci mollis, id condimentum arcu congue. Fusce neque erat, ultricies nec quam non, accumsan porta turpis. Phasellus fermentum, ipsum commodo vehicula volutpat, nunc mi varius neque, a molestie tortor tortor ut quam. In egestas sit amet quam quis rutrum. Vestibulum et tellus et ex finibus dapibus. Aenean et enim id nisl lacinia imperdiet. Curabitur at mauris vel enim aliquam commodo. Sed elementum vestibulum quam, vel accumsan arcu. Pellentesque ac eleifend nisi, vitae mattis erat. Pellentesque vitae nibh nec eros venenatis vulputate.  Sed odio odio, auctor non cursus at, egestas ut augue. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Phasellus fermentum, nulla ut ornare tincidunt, ante justo placerat augue, vitae malesuada mauris mauris et enim. Ut semper augue elit, et congue eros vulputate ut. Proin ac cursus erat. Aenean diam purus, tristique quis interdum sit amet, viverra eget nisl. Nulla ut commodo tortor. Vestibulum tempus nibh vel lacus congue vehicula. Mauris gravida sapien purus, quis suscipit risus efficitur quis. Nullam auctor porta mollis. Morbi ut lacus pellentesque, gravida est eu, vestibulum tellus. Vestibulum scelerisque orci velit, et mollis magna tempus aliquam. In laoreet, metus vitae gravida vehicula, nulla arcu posuere felis, non tincidunt ipsum nunc eget nisi. Donec et quam quis risus tempus sagittis. Sed sed volutpat elit. Aenean nec rutrum ante. Nam porttitor bibendum elit, vitae sagittis turpis maximus nec. Quisque lacinia eros vitae quam molestie, eu vehicula ipsum accumsan. Duis eget velit quis tellus malesuada tempor. Vivamus blandit neque ac leo condimentum aliquet. Vivamus id placerat ipsum. Interdum et malesuada fames ac ante ipsum primis in faucibus. In laoreet, metus vitae gravida vehicula, nulla arcu posuere felis, non tincidunt ipsum nunc eget nisi. Donec et quam quis risus tempus sagittis. Sed sed volutpat elit. Aenean nec rutrum ante. Nam porttitor bibendum elit, vitae sagittis turpis maximus nec. Quisque lacinia eros vitae quam molestie, eu vehicula ipsum accumsan. Duis eget velit quis tellus malesuada tempor. Vivamus blandit neque ac leo condimentum aliquet. Vivamus id placerat ipsum. Interdum et malesuada fames ac ante ipsum primis in faucibus.';

  const onActionClick = () => {
    onAcceptClick();
    close();
  };

  const ModalContent = () => (
    <Grid className="contract-text-comtainer">{text}</Grid>
  );
  const ModalAction = () => (
    <Button
      variant="contained"
      color="primary"
      className={classes.submitBtn}
      disableRipple
      onClick={onActionClick}
    >
      Accept & close
    </Button>
  );

  return (
    <Modal
      open={show}
      onClose={close}
      title={title}
      ModalContent={ModalContent}
      ModalAction={ModalAction}
      className="terms-modal"
    ></Modal>
  );
};

export default TermsAndConditionsModal;
